import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  /** @deprecated pass children instead */
  label?: React.ReactNode;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  /** @deprecated ignored, use className instead */
  size?: string;
}

export default function PrimaryButton({ children, label, prefixIcon, suffixIcon, size: _size, className = "", ...rest }: Props) {
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center gap-2 bg-[var(--color-primary)] text-white font-semibold text-sm px-4 py-2 rounded-[var(--ds-button-radius)] hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {prefixIcon}
      {children ?? label}
      {suffixIcon}
    </button>
  );
}
